import React from "react";
import { Link, useLocation } from "react-router-dom";

const Breadcrumbs = ({ title, url, profile, pricing, primerBank, quotereq }) => {
  const location = useLocation();

  return (
    <nav className="h-[52px] bg-[var(--color-secondary-gray)] flex items-center justify-center sm:justify-start px-10 xl:px-16 font-bold text-[14px] sm:text-[16px]">
      <p      
        className={`cursor-default ${
          location.pathname === "/" ? "text-[#000000]" : "text-[#58595B]"
        }`}
      >
        Account
      </p>
      <span className=" mx-2 sm:mx-3">&gt;</span>
      {quotereq ?
        <p
          // to="/quoterequest"
          className={
            location.pathname.startsWith("/")
              ? "cursor-default text-[#000000]"
              : "cursor-default text-[#58595B]"
          }
        >
          Quote Request
        </p>
        :
        <Link
        to="/dashboard"
        className={
          location.pathname.startsWith("/dashboard")
            ? "text-[#000000]"
            : "text-[#58595B]"
        }
      >
        Dashboard
      </Link>
      }
      
      {title ? (
        <Link
          to={`/orders/${url}`}
          className={
            location.pathname === `/orders/${url}`
              ? "text-[#000000]"
              : "text-[#58595B]"
          }
        >
          <span className="mx-2 sm:mx-3">&gt;</span>
          <span>{title}</span>
        </Link>
      ) : null}
      {profile ? (
        <Link
          to={`/${url}`}
          className={
            location.pathname === `/${url}`
              ? "text-[#000000]"
              : "text-[#58595B]"
          }
        >
          <span className="mx-2 sm:mx-3">&gt;</span>
          <span>{profile}</span>
        </Link>
      ) : null}
      {pricing ? (
        <Link
          to={`/${url}`}
          className={
            location.pathname === `/${url}`
              ? "text-[#000000]"
              : "text-[#58595B]"
          }
        >
          <span className="mx-2 sm:mx-3">&gt;</span>
          <span>{pricing}</span>
        </Link>
      ) : null}
      {primerBank ? (
        <Link
          to={`/${url}`}
          className={
            location.pathname === `/${url}`
              ? "text-[#000000]"
              : "text-[#58595B]"
          }
        >
          <span className="mx-2 sm:mx-3">&gt;</span>
          <span>{primerBank}</span>
        </Link>
      ) : null}
    </nav>
  );
};

export default Breadcrumbs;
